<template>
  <v-container>
    <v-layout align-center>
      <v-btn
        color="primary"
        icon
        @click="decrement"
        :disabled="value <= 0"
      >
        <v-icon>$minus-circle</v-icon>
      </v-btn>
      {{ value }}
      <v-btn
        color="primary"
        icon
        @click="increment"
        :disabled="value >= Math.min(leftSlots + cartCount, maxSlots)"
      >
        <v-icon>$plus-circle</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    leftSlots: {
      type: Number,
      default: 0
    },
    maxSlots: {
      type: Number,
      default: 0
    },
    cartCount: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    value: 0,
    initialLeftSlots: 0
  }),
  watch: {
    value (val) {
      this.$emit('input', val)
    },
    cartCount: {
      immediate: true,
      handler (newVal) {
        this.value = newVal
      }
    }
  },
  methods: {
    increment () {
      const availableSlots = this.leftSlots + this.cartCount
      const maxAllowed = Math.min(availableSlots, this.maxSlots)

      if (this.value < maxAllowed) {
        this.value++
        this.$emit('increment', this.value)
      }
    },
    decrement () {
      if (this.value > 0) {
        this.value--
        this.$emit('decrement', this.value)
      }
    },
    decrementSilently () {
      if (this.value > 0) {
        this.value--
      }
    }
  }
}
</script>
